var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"cursor-pointer",attrs:{"effect":"dark","content":_vm.helper,"placement":"top-start"}},[_c('span',[_vm._v(_vm._s(_vm.text)+" "),_c('i',{staticClass:"el-icon-question"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }